// Filled circle with a white minus.
const NotCheckedIcon = ({ className, color }: { className?: string; color: string }) => (
    <svg className={className} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <circle cx="8" cy="8" r="7" fill={color} />
        <rect x="4.5" y="7.25" width="7" height="1.5" rx="0.75" fill="white" />
    </svg>
);

export default NotCheckedIcon;
